import * as React from 'react';
import { IconProps } from '../types';

const IcNotReturn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M23 12c0 2.158-.652 4.164-1.768 5.832L16.399 13h4.1V7h-1.777v4H7.877l3.2-3.6L9.833 6l-.65.73-3.067-3.067A10.454 10.454 0 0 1 12.499 1.5C18.3 1.5 23 6.201 23 12ZM4.591 5.092A10.46 10.46 0 0 0 2 12c0 5.799 4.7 10.5 10.5 10.5 2.899 0 5.524-1.175 7.424-3.075L13.499 13H7.877l3.2 3.6L9.833 18 4.5 12l3.294-3.706-3.202-3.202ZM24.5 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcNotReturn;
